<p class="finzy-p7">Reject Loan Offer</p>

<form style="text-align:center;" (keydown.enter)="$event.preventDefault()" name="form" (ngSubmit)="f.form.valid && dialogRef.close(rejectreason)" #f="ngForm" novalidate>

	<!-- <div class="row">
		<mat-select placeholder="Select reject reason"  required name="rejectpurpose" [(ngModel)]="rejectpurpose" style="width:70%">
		  <mat-option *ngFor="let rs of rejectpurposes" [value]="rs.reason" required>
		    {{ rs.reason }}
		  </mat-option>
		</mat-select>
	</div> -->
    <div class="row" style="margin-top: 20px;">
        <mat-form-field style="width: 70%">
            <textarea matInput  placeholder="Enter loan rejection reason" [(ngModel)]="rejectreason" name="rejectreason"  required></textarea>
        </mat-form-field>
    </div>

    <div class="row finzy-create-portfolio-err" [hidden]="!(rejectreason == null || undefined || '')" style="color:red;float: left;">Please fill out loan rejection reason</div>
    
    <div class="row">
        <button  mat-stroked-button class="primary mt-4" type="submit">REJECT OFFER</button>
    </div>
    
</form>
